<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" :style="{width: width + 'px'}">
					<div class="modal-header">
						<slot name="header">
							default header
						</slot>
					</div>

					<FeedbackPanel class="pt-2"></FeedbackPanel>

					<div class="modal-body" :style="{height: height +  'px'}">
						<slot name="body">
							default body
						</slot>
					</div>

					<div class="modal-footer">
						<slot name="footer">
							<button class="modal-default-button btn btn-secondary" @click="$emit('close')">
								{{ cancelButton }}
							</button>
							<button v-if="showOkButton" class="modal-default-button btn btn-primary"
									@click="$emit('ok')">{{ okButton }}
							</button>
						</slot>
					</div>
				</div>
			</div>
		</div>

	</transition>
</template>

<script>
import FeedbackPanel from "./FeedbackPanel";
import feedbackMixin from '@/mixins/feedback'

export default {
	name: "Modal",
	components: {FeedbackPanel},
	mixins: [feedbackMixin],
	props: {
		showAddModal: Boolean,
		okButton: {
			type: String,
			default: 'OK'
		},
		showOkButton: {
			type: Boolean,
			default: true
		},
		cancelButton: {
			type: String,
			default: 'Cancel'
		},
		width: {
			type: String,
		},
		height: {
			type: String,
		},
		initialHeight: {
			type: Boolean,
			default: true
		},
		initialWidth: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedWidth() {
			return this.data;
		}
	},
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 40px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    /*font-family: Helvetica, Arial, sans-serif;*/
}

.modal-header h3 {
    margin-top: 0;
    color: rgb(131, 186, 35);
}

.modal-header {
    padding-top: 0 !important;
    padding-bottom: 0.5em !important;
}

.modal-footer {
    padding-bottom: 0 !important;
}

.modal-body {
    margin: 20px 0;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.modal-default-button {
    float: right;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>